var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrivacy(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.059,
    height: 17.051,
    viewBox: "0 0 17.059 17.051",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_488399",
    "data-name": "Group 488399",
    transform: "translate(-0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_180797",
    "data-name": "Path 180797",
    d: "M114.512,134.22l.283.023a.546.546,0,0,1,.574.594c0,1.442.015,2.884,0,4.326a1.962,1.962,0,0,1-1.882,1.883q-2.1.027-4.193,0a1.947,1.947,0,0,1-1.845-1.736c-.03-.35,0-.7,0-1.105H107c-2.352,0-4.7-.027-7.055.012a1.539,1.539,0,0,1-1.628-1.627c.03-3.672.013-7.344.013-11.016A1.431,1.431,0,0,1,99.9,124.01h12.18a1.423,1.423,0,0,1,1.579,1.584c0,1.575-.006,3.151.009,4.726a1.044,1.044,0,0,0,.188.568,3.154,3.154,0,0,1,.654,1.912C114.511,133.264,114.512,133.728,114.512,134.22ZM98.92,126.875c-.008.1-.017.168-.017.233q0,4.792,0,9.584a.865.865,0,0,0,.973.958q3.627,0,7.255,0c.085,0,.169-.014.289-.024v-.377c0-.765,0-1.531,0-2.3,0-.515.156-.674.661-.713a1.574,1.574,0,0,0,.179-.037c0-.453-.006-.9,0-1.337a3.127,3.127,0,0,1,4.62-2.8,1.761,1.761,0,0,0,.2.073v-3.268Zm9.161,12.465a.441.441,0,0,0-.028.118.424.424,0,0,0,.037.126,1.318,1.318,0,0,0,1.153.874c.541.036,1.086.021,1.629.021.876,0,1.752.013,2.627-.017a1.286,1.286,0,0,0,1.241-1.122c-.246,0-.486,0-.726,0-.192,0-.338-.069-.337-.276s.136-.284.334-.28c.252.005.5,0,.748,0,.092-.581.092-.581-.441-.582h-.2c-.2,0-.435.012-.441-.27s.214-.289.427-.284.438,0,.669,0v-.584a5.161,5.161,0,0,1-.78-.012.437.437,0,0,1-.307-.252c-.04-.193.11-.29.311-.287.252,0,.5,0,.778,0v-.584c-.261,0-.5,0-.743,0-.208.006-.361-.064-.356-.29,0-.209.158-.268.348-.265.249,0,.5,0,.756,0v-.557H108v.557c.244,0,.473,0,.7,0,.2,0,.4.009.407.271s-.191.286-.4.283c-.238,0-.477,0-.715,0v.583c.256,0,.5,0,.737,0,.195,0,.37.034.374.272s-.166.283-.364.281c-.249,0-.5,0-.746,0v.584a4.717,4.717,0,0,1,.769.012.469.469,0,0,1,.328.264c.045.2-.131.276-.32.276H108v.583a5.381,5.381,0,0,1,.8.013c.114.018.206.171.308.262-.1.093-.193.245-.307.265A4.226,4.226,0,0,1,108.081,139.34Zm.73-5.1c1.7,0,3.332,0,4.958-.009.063,0,.18-.129.18-.2a13.8,13.8,0,0,0-.042-1.592,2.536,2.536,0,0,0-4.978-.236A15.592,15.592,0,0,0,108.811,134.241Zm4.294-7.98v-.467c0-.973-.24-1.212-1.219-1.212H100.047a3.2,3.2,0,0,0-.464.023.75.75,0,0,0-.648.625c-.034.335-.008.677-.008,1.031Z",
    transform: "translate(-98.316 -124.01)",
    fill: "#8e92a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180799",
    "data-name": "Path 180799",
    d: "M124.729,184.387v2.245h2.25c0-.243,0-.484,0-.725,0-.2.083-.37.294-.369s.294.165.291.371c0,.244.009.489,0,.732a.578.578,0,0,1-.621.594q-1.082.01-2.164,0a.555.555,0,0,1-.62-.617q-.012-1.1,0-2.2a.528.528,0,0,1,.575-.585c.355-.009.71,0,1.065,0,.2,0,.355.083.309.285a.465.465,0,0,1-.305.254,2.146,2.146,0,0,1-.53.012Z",
    transform: "translate(-122.429 -179.851)",
    fill: "#8e92a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180800",
    "data-name": "Path 180800",
    d: "M124.737,258.95h2.248c0-.239,0-.478,0-.717,0-.2.042-.4.3-.392s.288.2.288.4,0,.422,0,.632a.582.582,0,0,1-.659.654q-1.048.013-2.1,0c-.456-.005-.648-.2-.652-.649q-.009-1.048,0-2.1c0-.458.212-.659.678-.666.288,0,.577,0,.865,0,.214,0,.425.026.419.3-.006.253-.2.283-.406.282-.3,0-.6,0-.9.006a.365.365,0,0,0-.082.027Z",
    transform: "translate(-122.436 -247.318)",
    fill: "#8e92a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180801",
    "data-name": "Path 180801",
    d: "M190.477,209.776c-.565,0-1.129,0-1.694,0-.2,0-.4-.02-.409-.275-.013-.282.2-.308.41-.308H192.2c.208,0,.4.054.4.294s-.186.293-.4.291C191.628,209.773,191.052,209.776,190.477,209.776Z",
    transform: "translate(-182.377 -203.522)",
    fill: "#8e92a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180802",
    "data-name": "Path 180802",
    d: "M138.918,185.383c.429-.516.8-.955,1.162-1.4.14-.171.3-.3.5-.124s.071.333-.057.486c-.418.5-.83,1.005-1.253,1.5-.234.274-.335.272-.594.021a2.379,2.379,0,0,1-.412-.428,1.119,1.119,0,0,1-.056-.435,1.275,1.275,0,0,1,.432.043C138.746,185.1,138.809,185.245,138.918,185.383Z",
    transform: "translate(-135.551 -179.799)",
    fill: "#8e92a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180803",
    "data-name": "Path 180803",
    d: "M138.868,258.689c.346-.416.67-.806.994-1.195.071-.085.13-.2.222-.242a1.338,1.338,0,0,1,.379-.06c.018.136.1.323.043.4-.447.577-.913,1.14-1.4,1.684a.443.443,0,0,1-.425.018,2.119,2.119,0,0,1-.538-.535c-.066-.093-.015-.269-.017-.408a1.051,1.051,0,0,1,.388.017A1.65,1.65,0,0,1,138.868,258.689Z",
    transform: "translate(-135.46 -248.325)",
    fill: "#8e92a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180804",
    "data-name": "Path 180804",
    d: "M189.766,187.91a10.068,10.068,0,0,1,1.03.012.465.465,0,0,1,.339.255c.059.228-.137.3-.331.3q-1.064.007-2.129,0c-.18,0-.339-.06-.335-.281s.159-.29.362-.288C189.056,187.913,189.411,187.91,189.766,187.91Z",
    transform: "translate(-182.346 -183.649)",
    fill: "#8e92a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180805",
    "data-name": "Path 180805",
    d: "M189.827,261.1c-.355,0-.709,0-1.064,0-.195,0-.355-.083-.315-.283a.413.413,0,0,1,.292-.264q1.1-.035,2.193,0a.418.418,0,0,1,.3.259c.044.2-.114.288-.309.288Z",
    transform: "translate(-182.442 -251.448)",
    fill: "#8e92a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180806",
    "data-name": "Path 180806",
    d: "M189.613,282.462c-.31,0-.62,0-.931,0-.186,0-.337-.054-.334-.276s.14-.28.332-.279c.62,0,1.241-.013,1.861.013.118.005.229.171.343.263-.114.093-.219.251-.343.267A7.406,7.406,0,0,1,189.613,282.462Z",
    transform: "translate(-182.354 -271.392)",
    fill: "#8e92a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180807",
    "data-name": "Path 180807",
    d: "M280.98,308.434a1,1,0,0,1,.687-.851.862.862,0,0,1,.987.423.793.793,0,0,1-.2,1.017.586.586,0,0,0-.27.609.438.438,0,0,1-.03.258c-.062.089-.182.211-.258.2a.5.5,0,0,1-.268-.235.461.461,0,0,1-.011-.26.545.545,0,0,0-.239-.552A2.161,2.161,0,0,1,280.98,308.434Zm1.3-.047c-.181-.125-.306-.272-.385-.25-.112.03-.19.185-.282.286.1.083.194.225.3.232S282.112,308.52,282.284,308.387Z",
    transform: "translate(-268.819 -295.334)",
    fill: "#8e92a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180808",
    "data-name": "Path 180808",
    d: "M188.088,140.9h3.592c.089,0,.2-.028.261.014a.5.5,0,0,1,.227.273c.011.078-.105.207-.2.257a.71.71,0,0,1-.325.034q-3.575,0-7.151,0h-.133c-.208,0-.4-.053-.4-.292s.188-.289.4-.288C185.6,140.9,186.846,140.9,188.088,140.9Z",
    transform: "translate(-178.259 -139.768)",
    fill: "#8e92a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180809",
    "data-name": "Path 180809",
    d: "M120.374,140.988c.241-.006.447.025.436.3-.01.255-.217.271-.413.275s-.408-.038-.415-.277C119.974,141.031,120.173,140.971,120.374,140.988Z",
    transform: "translate(-118.539 -139.855)",
    fill: "#8e92a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180810",
    "data-name": "Path 180810",
    d: "M163.143,140.033c.114.117.315.228.325.353.019.255-.211.3-.427.292s-.4-.046-.4-.294C162.645,140.111,162.861,140.09,163.143,140.033Z",
    transform: "translate(-158.358 -138.966)",
    fill: "#8e92a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180811",
    "data-name": "Path 180811",
    d: "M141.917,141.644c-.27-.077-.493-.074-.491-.359,0-.254.188-.286.393-.287s.443.022.412.289C142.216,141.417,142.027,141.526,141.917,141.644Z",
    transform: "translate(-138.555 -139.867)",
    fill: "#8e92a4"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacy);
export default __webpack_public_path__ + "static/media/privacy.5139d098ef9cb9dd07f40c2735d0e669.svg";
export { ForwardRef as ReactComponent };